export const sxStyle = {
  gridContainer: {
    bgcolor: '#F6F6F6',
    height: { xs: '350px', sm: '750px' },
  },

  title: {
    ml: { xs: '5px', sm: '185px' },
    mt: { xs: '10px', sm: '40px' },
    mb: { xs: '-30px', sm: '100px' },
  },

  titleWork: {
    mb: { xs: '40px', sm: '20px' },
  },

  subTitle: {
    width: { xs: '100%', sm: '80%' },
    bgcolor: '#E5E5E5',
    height: '180px',
    display: 'flex',
    placeContent: 'center',
    flexDirection: { xs: 'row', sm: 'column' },
  },

  itemSubTitle: {
    pl: { xs: '5px', sm: '185px' },
    display: 'flex',
    placeItems: 'center',
  },

  textSubTitle: {
    fontSize: { xs: '14px', sm: '20px' },
    fontWeight: 600,
    color: '#000',
  },

  image: {
    minHeight: '250px',
    minWidth: '350px',
    display: { xs: 'none', sm: 'block' },
  },
};
